export const formData = {
  title: 'Фойдаланувчи қўшиш',

  data: [
    {
      type: 'select',
      label: 'Роль',
      name: 'role',
      multiple: false,
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'admin',
        'supervisorleader',
        'groupleader',
        'regionsupervisor',
      ],
    },

    {
      type: 'text',
      label: 'Фамилияси',
      name: 'lastName',
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'text',
      label: 'Исми',
      name: 'firstName',
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'text',
      label: 'Шарифи',
      name: 'middleName',
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'select',
      label: 'Ташкилот',
      name: 'organization',
      value: '',
      size: 12,
      permission: ['groupadmin', 'groupleader'],
    },
    {
      type: 'text',
      label: 'MacAddress soni',
      name: 'macCount',
      value: '',
      size: 12,
      permission: ['groupadmin', 'groupleader'],
    },
    // {
    //   type: "text",
    //   label: "Логин",
    //   name: "username",
    //   value: "",
    //   size: 12,
    //   permission: ["governor", "supervisor", "groupsecretary", "admin"],
    // },
    {
      type: 'password',
      label: 'Парол',
      name: 'password',
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'select',
      label: 'Вилоят',
      name: 'province',
      value: '',
      multiple: false,
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'select',
      label: 'Туман',
      name: 'region',
      value: '',
      multiple: false,
      size: 12,
      permission: ['groupadmin', 'regionsupervisor'],
    },
    {
      type: 'select',
      label: 'Туман',
      name: 'regions',
      value: '',
      multiple: true,
      size: 12,
      permission: ['groupleader'],
    },
    {
      type: 'select',
      label: 'Гуруҳ',
      name: 'group',
      value: '',
      multiple: true,
      size: 12,
      permission: [
        'groupadmin',
        'supervisor',
        'groupleader',
        'regionsupervisor',
      ],
    },
    // {
    //   type: 'select',
    //   label: 'МФЙ',
    //   name: 'object',
    //   value: '',
    //   multiple: false,
    //   size: 12,
    //   permission: ['groupadmin'],
    // },
    {
      type: 'searchSelect',
      label: 'МФЙ',
      name: 'object',
      value: '',
      multiple: false,
      size: 12,
      permission: ['groupadmin'],
    },
    {
      type: 'tel',
      label: 'Телефон рақами',
      name: 'phone',
      value: '',
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
    {
      type: 'switch',
      label: 'Фаоллиги',
      name: 'active',
      value: true,
      size: 12,
      permission: [
        'governor',
        'supervisor',
        'groupadmin',
        'supervisorleader',
        'admin',
        'groupleader',
        'regionsupervisor',
      ],
    },
  ],
};

export const initialValuesAdd = {
  firstName: '',
  lastName: '',
  middleName: '',
  username: '',
  password: '',
  province: '',
  organization: '',
  macCount: '',
  region: '',
  regions: [],
  object: '',
  group: [],
  role: '',
  phone: '',
  active: true,
};
